import request from '@/config/api'

/**
 * 首页相关API
 */
export const homeApi = {
  /**
   * 获取当前日期（确保使用正确的时区）
   * @returns {string} 格式：YYYY-MM-DD
   */
  getCurrentDate() {
    const now = new Date();
    // 使用本地时间，避免时区问题
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  },

  /**
   * 获取用户今日学习统计
   * @param {number} userId - 用户ID
   * @param {string} date - 日期，格式：YYYY-MM-DD
   */
  getTodayStats(userId, date = null) {
    return request({
      url: '/index/getTodayStats',
      method: 'get',
      params: {
        user_id: userId,
        date: date || this.getCurrentDate()
      }
    })
  },

  /**
   * 更新用户学习统计
   * @param {number} userId - 用户ID
   * @param {object} data - 统计数据
   * @param {string} date - 日期，格式：YYYY-MM-DD
   */
  updateStats(userId, data, date = null) {
    // 直接发送扁平化的数据，不嵌套在data字段中
    const postData = {
      user_id: userId,
      date: date || this.getCurrentDate(),
      ...data  // 展开统计数据到根级别
    }
    
    return request({
      url: '/index/updateStats',
      method: 'post',
      data: postData
    })
  },

  /**
   * 获取用户学习阶段数据
   * @param {number} userId - 用户ID
   */
  getLearningStages(userId) {
    return request({
      url: '/index/getLearningStages',
      method: 'get',
      params: {
        user_id: userId
      }
    })
  },


  /**
   * 更新课程学习进度
   * @param {number} userId - 用户ID
   * @param {number} stageId - 课程阶段ID
   * @param {number} studyTime - 学习时长（分钟）
   */
  updateCourseProgress(userId, stageId, studyTime) {
    return request({
      url: '/index/updateCourseProgress',
      method: 'post',
      data: {
        user_id: userId,
        stage_id: stageId,
        study_time: studyTime
      }
    })
  },

  /**
   * 获取用户课程列表
   * @param {number} userId - 用户ID
   */
  getUserCourses(userId) {
    return request({
      url: '/index/getUserCourses',
      method: 'get',
      params: {
        user_id: userId
      }
    })
  },

  /**
   * 获取需要复习的单词（受今日目标限制）
   */
  getReviewWords() {
    return request({
      url: '/review/getTodayReviewWords',
      method: 'get'
    })
  },

  /**
   * 获取记忆曲线复习单词（不受今日目标限制）
   */
  getMemoryCurveReviewWords() {
    return request({
      url: '/review/getMemoryCurveReviewWords',
      method: 'get'
    })
  },

  /**
   * 提交学习结果
   * @param {Object} learningData - 学习数据
   */
  submitLearning(learningData) {
    return request({
      url: '/review/submitLearning',
      method: 'post',
      data: learningData
    })
  },

  /**
   * 获取今日新分配的学习单词
   * @param {number} userId - 用户ID
   */
  getDailyNewWords(userId) {
    return request({
      url: '/index/getDailyNewWords',
      method: 'get',
      params: {
        user_id: userId
      }
    })
  },

  /**
   * 切换用户学习阶段并重新分配今日单词
   * 后端会保存 current_stage_id、清除今日未学习的旧分配、用新阶段重新分配
   * @param {number} userId - 用户ID
   * @param {number} stageId - 目标阶段ID
   */
  switchStage(userId, stageId) {
    return request({
      url: '/index/switchStage',
      method: 'post',
      data: {
        user_id: userId,
        stage_id: stageId
      }
    })
  }
}
